import {ModuleController} from "../../../../infrastructure/controllers/module-controller";
import {BaseManagedService} from "../../../../infrastructure/domain-services/base-managed-service";
import {CompetitionBracketsPageConfig} from "./competition-brackets-page.config";
import {CompetitionBracketsPageHandlers} from "./handlers/competition-brackets-page.handlers";
import {CompetitionBracketsPageStore} from "./competition-brackets-page.store";

export class CompetitionBracketsPageController extends ModuleController {
  static injectables = [...BaseManagedService.injectables, CompetitionBracketsPageConfig, CompetitionBracketsPageStore, CompetitionBracketsPageHandlers];

}
